import { token } from '@cp/shared/di';
import { AsyncResult } from '@youhelp-ru/core';
import { ClientSelection } from 'src/entities/client';

export const CATALOG_QUIZ =
  token<(q: Array<keyof ClientSelection>, override: ClientSelection) => AsyncResult<ClientSelection, unknown>>('CATALOG_QUIZ');
